import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RevealDirective } from '../../../core/directives/reveal.directive';

@Component({
  selector: 'app-hero',
  imports: [TranslatePipe, RevealDirective],
  templateUrl: './hero.html',
  styleUrl: './hero.scss',
})
export class Hero {}
